export default () => ({
  radioButton: {
    padding: '6px',
  },
  radioLabel: {
    marginLeft: '-10px',
  },
  assigneeInput: {
    top: '-38px',
    right: '-26px',
    width: '260px',
  },
});
